import { useContext, useMemo } from 'react'
import {
  buildPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import { trackEvent } from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'

interface Props {
  cruiseTypes?: Set<string>
  onChange: (value: any) => void
  cruiseTypeFacets: Array<App.CruiseSearchFacetV2Item>
}

function CruiseCruiseTypeFilter({
  cruiseTypes,
  onChange,
  cruiseTypeFacets,
}: Props) {
  const globalSearchState = useContext(GlobalSearchStateContext)

  const { cruiseTypeItems, hasCruiseTypes } = useMemo(() => {
    return {
      cruiseTypeItems: buildPanelCheckItems(cruiseTypeFacets),
      hasCruiseTypes: cruiseTypeFacets.some(facet => facet.count > 0),
    }
  }, [cruiseTypeFacets])

  if (!hasCruiseTypes) {
    return null
  }

  return <div data-testid="cruise-type-filter">
    <FilterPanelCheckboxGroup
      name="cruiseTypes"
      items={cruiseTypeItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: e.target.value,
            type: 'cruise_type',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))

        onChange(e)
      }}
      defaultSelected={cruiseTypes}
    />
  </div>
}

export default CruiseCruiseTypeFilter
